interface InputPropsUseState<T> {
    value: T;
    setValue: React.Dispatch<React.SetStateAction<T>>;
    enumType: { [s: string]: T };
}
    
function EnumInputUseState<T extends string>({ value, setValue, enumType }: InputPropsUseState<T>) {
    const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setValue(event.target.value as T);
    };

    return (
        <select value={value} onChange={handleChange}>
            {Object.values(enumType).map((enumValue) => (
                <option key={enumValue} value={enumValue}>
                    {enumValue}
                </option>
            ))}
        </select>
    );
}

/*

interface InputPropsRegular<T> {
    value: T;
    enumType: { [s: string]: T };
}
    
function EnumInputRegular<T extends string>({ value, enumType }: InputPropsRegular<T>) {
    const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        value = event.target.value as T;
    };

    return (
        <select value={value} onChange={handleChange}>
            {Object.values(enumType).map((enumValue) => (
                <option key={enumValue} value={enumValue}>
                    {enumValue}
                </option>
            ))}
        </select>
    );
}

*/

interface InputPropsRegular<T extends string> {
    value: T;
    enumType: { [key: string]: T };
    onChange: (value: T) => void;
}

function EnumInput<T extends string>({ value, enumType, onChange }: InputPropsRegular<T>) {
    const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const newValue = event.target.value as T;
        onChange(newValue);
    };

    return (
        <select className="enum-input" value={value} onChange={handleChange}>
            {Object.values(enumType).map((enumValue) => (
                <option key={enumValue} value={enumValue}>
                    {enumValue}
                </option>
            ))}
        </select>
    );
}

export {EnumInput as default, EnumInputUseState} ;